import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

// common styles used on all three dynamically generated daily unit vals pages
// - /annuities/daily-unit-values/daily-unit-values-income-annuities/
// - /fixed-annuity-vs-variable-annuity/daily-unit-values/daily-unit-values-deferred-annuities/
// - /life-insurance/universal-life-insurance/daily-unit-values-universal-life-insurance/

export const ColStyled = styled(Col)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    const smallDown = theme.smallDown();
    return css`
      padding-bottom: ${mediumUp ? rem(60) : rem(48)};
      overflow-x: ${smallDown ? 'auto' : 'none'};
    `;
  }
}`;

export const TableStyled = styled.table`
  width: 100%;
`;

export const TBodyStyled = styled.tbody`
  ${({ theme }) => {
    return css`
      tr:nth-child(even) {
        background-color: ${theme.colors.neutral.grayLight2};
      }
    `;
  }
}`;

export const TDStyled = styled.td`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding: ${mediumUp ? rem(10) : 0};
    `;
  }
}`;

export const THStyled = styled.th`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      padding: ${mediumUp ? rem(10) : 0};
      text-align: left;
      font-weight: 400;
    `;
  }
}`;

export const THeadStyled = styled.thead`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      background-color: ${theme.colors.blue.blue};
      text-align: left;
      padding: ${mediumUp ? rem(10) : 0};
    `;
  }
}`;

export const TypographyStyledTableHeading = styled(Typography)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      font-weight: 500;
      padding: ${mediumUp ? rem(10) : 0};
    `;
  }
}`;

export const ULStyled = styled.ul`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      list-style: none;
      padding-left: ${rem(5)};
      padding-bottom: ${mediumUp ? rem(40) : rem(32)};
    `;
  }
}`;

